import { createViewModelContext } from '@caudena/core/utils/mobxUtils'
import { ICaseActionsController } from './CaseActionsController'

export const {
  ViewModelProvider: CaseActionsProvider,
  useViewModel: useCaseActions,
} = createViewModelContext<ICaseActionsController>()
